import { focusAtom } from 'jotai-optics';

import { baseSearchFormAtom } from './Search';

export const metaAtom = focusAtom(baseSearchFormAtom, (optic) =>
    optic.prop('meta')
);

export const priceRangeMetaAtom = focusAtom(metaAtom, (optic) =>
    optic.prop('priceRange')
);

export const tourOperatorMetaAtom = focusAtom(metaAtom, (optic) =>
    optic.prop('tourOperator')
);

export const flightMetaAtom = focusAtom(metaAtom, (optic) =>
    optic.prop('flight')
);

export const transferMetaAtom = focusAtom(metaAtom, (optic) =>
    optic.prop('transfer')
);

export const accommodationMetaAtom = focusAtom(metaAtom, (optic) =>
    optic.prop('accommodation')
);

export const specialMetaAtom = focusAtom(metaAtom, (optic) =>
    optic.prop('special')
);

export const popularFilterListMetaAtom = focusAtom(metaAtom, (optic) =>
    optic.prop('popularFilterList')
);

export const tourOperatorCategoryMetaAtom = focusAtom(metaAtom, (optic) =>
    optic.prop('tourOperatorCategory')
);

export const paymentTypeMetaAtom = focusAtom(metaAtom, (optic) =>
    optic.prop('paymentType')
);
